import { z } from 'zod'
import { ZugmeldestelleNameSchema } from '../../Generic/schema/generic.schema'
import { Betriebsstellenart } from '../../../../types'

// Default constants
const DEFAULT_AUFTRAG22_10 = {
  enabled: true,
  selector: '' as const,
  name: ''
}

const DEFAULT_BEFEHL_22_FORM = {
  auftrag22_10: DEFAULT_AUFTRAG22_10
}

// Schema definitions
const Auftrag22_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG22_10.enabled),
    selector: z
      .enum(['', Betriebsstellenart.Bf, Betriebsstellenart.Bft])
      .default(DEFAULT_AUFTRAG22_10.selector),
    name: ZugmeldestelleNameSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG22_10))

// Base schema
const Befehl22FormSchemaBase = z
  .object({
    auftrag22_10: Auftrag22_10Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_22_FORM))

export const Befehl22FormSchema = Befehl22FormSchemaBase

// Validation schema factory
export const createBefehl22FormValidationSchema = () => {
  return Befehl22FormSchemaBase
}

export type Befehl22FormData = z.infer<typeof Befehl22FormSchemaBase>
